export default __webpack_public_path__ + "static/media/travel.15f50ac8.svg";